module.exports = __webpack_public_path__ + "images/emoji/confounded.d488a1d546fe72466551.png";